export default "__VITE_ASSET__B36q1xS0__"